import { Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { UserNotesComponent } from '@zero/shared/ui-web-components';
import { DividerComponent } from '@zero/shared/ui-web-design-system';
import { BaseComponent } from '../../components/base/base.component';
import { DepotComponent } from '../../components/depot/depot.component';
import { KontoDepotComponent } from '../../components/konto-depot/konto-depot.component';
import { KryptoWalletComponent } from '../../components/krypto-wallet/krypto-wallet.component';
import { KundenWerbenComponent } from '../../components/kunden-werben/kunden-werben.component';
import { NotificationAdministrationComponent } from '../../components/notification-administration/notification-administration.component';
import { SecurityComponent } from '../../components/security/security.component';
import { TaxComponent } from '../../components/tax/tax.component';
import { UserContactDataComponent } from '../../components/user-contact-data/user-contact-data.component';

@Component({
  templateUrl: './user-self-service.component.html',
  imports: [
    UserNotesComponent,
    KontoDepotComponent,
    KryptoWalletComponent,
    TaxComponent,
    UserContactDataComponent,
    DepotComponent,
    SecurityComponent,
    NotificationAdministrationComponent,
    KundenWerbenComponent,
    TranslocoPipe,
    DividerComponent,
  ],
})
export class UserSelfServiceComponent extends BaseComponent {}
